import React from 'react';
import RiskCalculator from '../../../../components/RiskCalculator';

const SectionRiskCalculator = () => {
  return <RiskCalculator />;
};

export default SectionRiskCalculator;